import { useState } from "react";
import type { AuthTokenResponse, User } from "@zenforge/shared";

interface LoginProps {
  onLoginSuccess: (user: User, token: string) => void;
}

export function Login({ onLoginSuccess }: LoginProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) return;

    try {
      setLoading(true);
      setError(null);
      const res = await fetch("/api/v1/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || "Login failed. Please check credentials.");
      }

      const data: AuthTokenResponse = await res.json();
      onLoginSuccess(data.user, data.token);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        minHeight: "80vh",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
      }}
    >
      <div
        className="card"
        style={{
          width: "100%",
          maxWidth: "420px",
          padding: "2rem",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
          <h2 style={{ fontSize: "1.75rem", fontWeight: 700, margin: "0 0 0.5rem 0" }}>
            Zen<span style={{ color: "var(--accent, #6366f1)" }}>Forge</span>
          </h2>
          <p style={{ opacity: 0.7, margin: 0, fontSize: "0.9rem" }}>
            Admin Operations Portal Login
          </p>
        </div>

        {error && <div className="callout error mb-4">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label style={{ display: "block", marginBottom: "0.4rem", fontWeight: 500 }}>
              Email Address
            </label>
            <input
              type="email"
              className="input"
              style={{ width: "100%" }}
              required
              placeholder="e.g. admin@zenmarks.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group mb-4">
            <label style={{ display: "block", marginBottom: "0.4rem", fontWeight: 500 }}>
              Password
            </label>
            <input
              type="password"
              className="input"
              style={{ width: "100%" }}
              required
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className="btn primary"
            style={{ width: "100%", padding: "0.7rem", fontSize: "1rem" }}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
